import { SearchableEntity, Entity, AuditDetails, ActionableEntity, Flag } from '../../entity';
import { ServiceTypeTag } from '../../shared/label';
import { SiteTiny } from '../../shared/site';
import { Contact } from '../../contact/contact';
import { ContactEntity, ContactEntityWithStatus } from '../../contact/contact.options';
import { MergeSiteRequest, MoveSiteRequest } from '../../contact/contact.site.request';
import { EntitySubStatus } from '../../entity.status/entity.status';
import { SiteProTiny } from './site.pro.tiny';
import { ServiceEntity } from '../../job/service.entity';
import { EntitySiteBulkAction } from '../../entities/common/entity.bulk.action';


export interface SitePro extends SiteProTiny, SearchableEntity, ActionableEntity, AuditDetails {

    parent: ContactEntityWithStatus;
    owner: ContactEntity;
    billTo: ContactEntity;
    contact: ContactEntity;
    manager?: ContactEntity;

    emailCC?: string;
    invoiceTheme?: Entity;

    phone?: string;
    email?: string;
    note?: string;

    /** Derived from the address postcode by the site pipeline (WBS-11093). Read-only — never set by hand. */
    zones?: Entity[];
    tags?: Entity[];

    /** Optional single classification, selected from Site Category tags rather than ordinary site tags. */
    siteCategory?: Entity | null;

    /** scheduling tag */
    schedulingTags?: Entity[];

    /** Return PriceLists for the parent and global */
    defaultSellPriceList?: Entity;
    customFields?: Record<string, any>;
    status?: EntitySubStatus;
    integrationId?: string;

    services: ServiceEntity[];

    processingConfirmationDate?: Date;

    stockLocation?: boolean;
}

export interface SiteProContacts extends SitePro {
    contact1: Contact;
    contact2: Contact;
    contact3: Contact;
}


export function toSite(site: SitePro): SiteTiny {
    return {
        _id: site._id,
        name: site.name,
        address: site.address,
    } as SiteTiny;
}


export enum EntitySiteCommandIds {
    Exists = 'Exists',
    ConfirmServices = 'ConfirmServices',
    UpdateStatus = 'UpdateStatus',
    RawSite = 'RawSite',
    DeactivateSite = 'DeactivateSite',
    MoveSite = 'MoveSite',
    MergeSite = 'MergeSite',
    Delete = 'Delete',
};

export type SiteCommands =
    {
        commandId: EntitySiteCommandIds.Exists,
        data: {
            id: string;
        }
    } |
    {
        commandId: EntitySiteCommandIds.ConfirmServices,
        data: EntitySiteBulkAction;
    } |
    {
        commandId: EntitySiteCommandIds.MoveSite,
        data: MoveSiteRequest;
    } |
    {
        commandId: EntitySiteCommandIds.MergeSite,
        data: MergeSiteRequest;

    } |
    {
        commandId: EntitySiteCommandIds.RawSite,
        data: {
            id: string;
        }
    }
